import React from 'react'
import Slider from 'components/Slider'

const RangeSlider = ({ value, start, end, icon, className, transformer, onChange }) => {
  const { min, max } = value || { min: start, max: end }

  return (
    <Slider
      className={className}
      icon={icon}
      minValue={start}
      maxValue={end}
      defaultValue={[start, end]}
      value={[min, max]}
      label={transformer ? `${transformer(min)} - ${transformer(max)}` : `${min} - ${max}`}
      onChange={values => onChange({ min: values[0], max: values[1] })}
    />
  )
}

export default RangeSlider
